/*
 * @Author: 黄智强
 * @Date: 2018-01-27 09:56:30
 * @Last Modified by: 黄智强
 * @说明：员工所需接口地址
 */
// 初始化用户角色
export const userRoleInitializeRole = '/user-role/initialize-role'
// 获取用户角色列表
export const userRoleGetRoleList = '/user-role/get-role-list'
// 用户角色权限 end
// 员工列表页面 start
// 获取所有员工列表
export const subAccountEmployeeList = '/sub-account/employee-list'
// 获取所有员工
export const subAccountGetAllEmployee = '/sub-account/get-all-employee'
// 创建子帐号
export const subAccountCreate = '/sub-account/create'
// 创建子帐号
export const subAccountEdit = '/sub-account/edit'
// 锁定或解锁子帐号
export const subAccountLock = '/sub-account/lock'
// 锁定或解锁子帐号
export const subAccountVerify = '/sub-account/verify'
// 批量删除子帐号
export const subAccountBatchDelete = '/sub-account/batch-delete'
// 获取员工业绩列表
export const subAccountGetEmployeePerformance = '/sub-account/get-employee-performance'
// 获取员工用户信息
export const subAccountGetEmployeeInfo = '/sub-account/get-employee-info'
// 员工列表页面 end
